"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProbeHint = void 0;
const Leaf = __importStar(require("leaf-ts"));
const probeHint_html_R_1 = require("./probeHint.html.R");
const probeHint_html_R_2 = require("./probeHint.theme/genesis/probeHint.html.R");
const probeHint_html_R_3 = require("./probeHint.theme/business/probeHint.html.R");
class ProbeHint extends probeHint_html_R_1.R.ProbeHint {
    constructor() {
        super(...arguments);
        this.onOpenGuide = () => {
        };
    }
    onClickOpenGuide(e) {
        e?.preventDefault();
        e?.stopPropagation();
        this.onOpenGuide();
    }
}
exports.ProbeHint = ProbeHint;
Leaf.WidgetThemeCenter.about(probeHint_html_R_1.R.ProbeHint).add("genesis", probeHint_html_R_2.R.ProbeHint.generator);
Leaf.WidgetThemeCenter.about(probeHint_html_R_1.R.ProbeHint).add("business", probeHint_html_R_3.R.ProbeHint.generator);
